import Transform from '@ember-data/serializer/transform';
import { camelize, underscore } from '@ember/string';

export default class NestedTransform extends Transform {
  deserialize(
    serialized: Record<string, unknown> | Array<Record<string, unknown>> | undefined
  ): Record<string, unknown> | Array<Record<string, unknown>> | undefined {
    if (!serialized) {
      return undefined;
    }
    return this.fncKeys(serialized, camelize);
  }

  serialize(
    deserialized: Record<string, unknown> | Array<Record<string, unknown>> | undefined
  ): Record<string, unknown> | Array<Record<string, unknown>> | undefined {
    if (!deserialized) {
      return undefined;
    }
    return this.fncKeys(deserialized, underscore);
  }

  fncKeys(
    object: Record<string, unknown> | Array<Record<string, unknown>> | undefined,
    fnc: (key: string) => string
  ): Record<string, unknown> | Array<Record<string, unknown>> | undefined {
    if (!object) {
      return undefined;
    }

    if (Array.isArray(object)) {
      return object.map(obj => this.fncKeys(obj, fnc) as Record<string, unknown>);
    }

    return Object.entries(object).reduce(
      (obj, [key, value]) => {
        obj[fnc(key)] = value;
        return obj;
      },
      {} as Record<string, unknown>
    );
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    hash: NestedTransform;
  }
}
